import React, { useState } from "react";

// GitHub Icon Component
const GitHubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

export default function MatchCard() {
  // Load saved values from localStorage or use defaults
  const [message, setMessage] = useState("");
  const [name, setName] = useState(() => {
    return localStorage.getItem('cardName') || "Penelope";
  });
  const [promptTitle, setPromptTitle] = useState(() => {
    return localStorage.getItem('cardPromptTitle') || "Unusual skills";
  });
  const [promptResponse, setPromptResponse] = useState(() => {
    return localStorage.getItem('cardPromptResponse') || "Getting my hoodie back after you've \"borrowed it\"";
  });
  const [yourResponse, setYourResponse] = useState(() => {
    return localStorage.getItem('cardYourResponse') || "smooth implication here…";
  });
  const [blurAmount, setBlurAmount] = useState(() => {
    return localStorage.getItem('cardBlurAmount') || 40;
  });
  const [saveStatus, setSaveStatus] = useState("");

  const handleSave = () => {
    localStorage.setItem('cardName', name);
    localStorage.setItem('cardPromptTitle', promptTitle);
    localStorage.setItem('cardPromptResponse', promptResponse);
    localStorage.setItem('cardYourResponse', yourResponse);
    localStorage.setItem('cardBlurAmount', blurAmount);
    
    setSaveStatus('Saved!');
    setTimeout(() => setSaveStatus(''), 2000);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Navbar */}
      <nav className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-2">
          <span className="text-2xl">💜</span>
          <h1 className="text-xl font-bold font-space-grotesk text-hinge-purple">
            Hinge Match Generator
          </h1>
        </div>
        <a
          href="https://github.com/bage0011/hings"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-600 hover:text-hinge-purple transition-colors"
          title="View on GitHub"
        >
          <GitHubIcon />
          <span className="font-space-grotesk text-sm font-medium hidden sm:inline">GitHub</span>
        </a>
      </nav>

      <div className="flex flex-1">
      {/* Left Panel - Edit Controls */}
      <div className="w-80 bg-white border-r border-gray-200 p-6 overflow-y-auto">
        <h3 className="text-xl font-bold font-space-grotesk text-black mb-6">Edit Card Content</h3>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold font-space-grotesk text-gray-700 mb-2">
              Woman's Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-hinge-purple transition-all"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold font-space-grotesk text-gray-700 mb-2">
              Prompt Title
            </label>
            <input
              type="text"
              value={promptTitle}
              onChange={(e) => setPromptTitle(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-hinge-purple transition-all"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold font-space-grotesk text-gray-700 mb-2">
              Her Response
            </label>
            <textarea
              value={promptResponse}
              onChange={(e) => setPromptResponse(e.target.value)}
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-hinge-purple transition-all resize-none"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold font-space-grotesk text-gray-700 mb-2">
              Your Response
            </label>
            <textarea
              value={yourResponse}
              onChange={(e) => setYourResponse(e.target.value)}
              rows={3}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-hinge-purple transition-all resize-none"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold font-space-grotesk text-gray-700 mb-2">
              Background Blur (px)
            </label>
            <div className="flex items-center gap-3">
              <input
                type="range"
                min="0"
                max="100"
                value={blurAmount}
                onChange={(e) => setBlurAmount(e.target.value)}
                className="flex-1"
              />
              <input
                type="number"
                min="0"
                max="100"
                value={blurAmount}
                onChange={(e) => setBlurAmount(e.target.value)}
                className="w-16 px-2 py-1 border border-gray-300 rounded focus:outline-none focus:border-hinge-purple text-center"
              />
            </div>
          </div>

          <button
            onClick={handleSave}
            className="w-full bg-hinge-purple hover:bg-hinge-darkPurple text-white py-3 rounded-lg font-space-grotesk font-bold text-base transition-all shadow-md hover:shadow-lg transform hover:scale-[1.01] active:scale-[0.99] mt-8"
          >
            {saveStatus || 'Save as Default'}
          </button>
        </div>
      </div>

      {/* Right Panel - Card Preview */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-sm mx-4 relative">
          {/* Blurred background image behind title and card */}
          <div 
            className="absolute inset-0 bg-cover bg-center rounded-3xl"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/assets/baddies/baddie.jpeg)`,
              filter: `blur(${blurAmount}px)`,
              top: '20px',
              bottom: '200px',
              left: '-20px',
              right: '-20px',
              opacity: '0.5'
            }}
          />
          
          <div className="relative z-10">
            <h2 className="text-4xl font-bold font-space-grotesk text-black tracking-tight mb-6">{name}</h2>

            <div className="bg-white rounded-2xl px-10 py-12 pb-20 shadow-lg relative mb-6">
              <div className="space-y-6">
                <p className="text-sm font-black font-space-grotesk text-gray-800 tracking-wide">{promptTitle}</p>
                <p className="text-3xl font-sans leading-snug text-black font-semibold">
                  {promptResponse}
                </p>
              </div>
              
              <div className="absolute -bottom-4 left-0 bg-hinge-responseBackground rounded-tr-xl rounded-tl-none rounded-br-xl rounded-bl-none px-2 py-1.5 shadow-lg">
                <p className="text-sm font-sans text-#1d0906 font-space-normal">
                  {yourResponse}
                </p>
              </div>
            </div>

            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write a message"
              className="w-full px-6 py-4 bg-white border border-gray-200 rounded-2xl focus:outline-none focus:border-gray-300 text-gray-#c3c3c3 placeholder-gray-400 transition-all shadow-md mb-3"
            />

            <button className="w-full bg-hinge-purple hover:bg-hinge-darkPurple text-white py-4 rounded-full font-space-grotesk font-bold text-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-[1.01] active:scale-[0.99] mb-4">
              Match with {name}
            </button>

            <button className="block mx-auto text-black text-base font-bold hover:text-gray-600 transition-colors">
              Cancel
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
